<template>
  <div>
    <SwappingSquaresSpinner v-if="this.$store.getters.isLoading"
      :animation-duration="1000"
      :size="90"
      :color="this.$store.getters.config.palette.primary"
      style="margin: 30px auto;"
    />
    <form v-if="!this.$store.getters.isLoading" @submit.prevent="onsubmit">
      <va-input
        v-model="password"
        type="password"
        :label="$t('auth.password')"
        :error="!!passwordErrors.length"
        :error-messages="passwordErrors"
      />

      <va-input
        v-model="passwordAgain"
        type="password"
        :label="$t('recover.confirmPassword')"
        :error="!!passwordAgainErrors.length"
        :error-messages="passwordAgainErrors"
      />

      <div class="d-flex justify--center mt-3">
        <va-button type="submit" class="my-0" style="background-image: unset; background-color: rgb(108, 127, 238); box-shadow: rgb(10 13 117 / 25%) 0 1px 1px 0;">{{ $t('auth.resetPassword') }}</va-button>
      </div>
    </form>
  </div>
</template>

<script>
import { SwappingSquaresSpinner } from 'epic-spinners'
import errorHandlerMixin from '@/mixin/errorHandlerMixin'
export default {
  components: { SwappingSquaresSpinner },
  mixins: [errorHandlerMixin],
  name: 'RecoverPasswordRedirect',
  data () {
    return {
      password: '',
      passwordAgain: '',
      passwordErrors: [],
      passwordAgainErrors: [],
      resetSuccessStatus: false,
    }
  },
  methods: {
    onsubmit () {
      if (!this.password || !this.passwordAgain) {
        this.passwordErrors = [this.$t('recover.requiredPassword')]
        this.passwordAgainErrors = [this.$t('recover.requiredConfirmPassword')]
      } else if (this.password !== this.passwordAgain) {
        this.passwordErrors = [this.$t('recover.passSameVerification')]
        this.passwordAgainErrors = [this.$t('recover.passSamePrimary')]
      } else {
        this.resetSuccessStatus = false
        this.$store.commit('setLoading', true)
        this.$store.dispatch('resetPass', {
          password: this.password,
          token: this.$route.params.token,
        }).then(() => this.$router.push({ name: 'login' })).catch((err) => this.errorHandler(err.response))
      }
    },
  },
  mounted () {
    this.$store.dispatch('resetPassTokenValidation', this.$route.params.token)
      .catch(() => this.$router.push({ name: 'login' }))
  },
}
</script>

<style scoped>

</style>
